import Card from "@mui/material/Card"
import StackedLineChart from '@mui/icons-material/BarChart';
import { BalanceItem, Summary } from "../../interface/Summary";
import Skeleton from "@mui/material/Skeleton";
import { User } from "../../interface/User";
import { DEFAULT_FUNDING_CURRENCY } from "../../const";
import { getBalanceForAsset } from "../../utils/getBalanceForAsset";
import { useState } from "react";
import Menu from "@mui/material/Menu";
import MoreVert from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { BuySellModal } from "../../components/modals/BuySellModal/BuySellModal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";
import { dashboardMutedTextSx, getDashboardPanelSx } from "./dashboardStyles";

interface CurrentFundsProps
{
  user: User
  loading: boolean
  summary: Summary | undefined
}


export const CurrentFunds = ({ loading, summary, user }: CurrentFundsProps) =>
{
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [ showSellModalWithPair, setShowSellModalPair ] = useState("")
  const [ freeAmount, setFreeAmount ] = useState(0)

    const getMaxSell = () =>
    {
      try
      {
        return freeAmount * Number(summary?.prices[showSellModalWithPair])
      }
      catch(error)
      {
        return 0
      }
    }
  
    const handleShowSellModal = (balanceItem: BalanceItem) =>
    { 
      setAnchorEl(null)
      if(!balanceItem.asset.startsWith("USDT"))
      {
        setShowSellModalPair(balanceItem.asset + "USDT")
        setFreeAmount(Number(balanceItem.free))
      }
    }

  return (
    <Card sx={{ ...getDashboardPanelSx(theme, 116), p: 2.5 }} elevation={0}>
    
    { loading ? <>

      <Skeleton height={30} width={30} variant="circular" /> 
      <Skeleton height={20} width="50%" sx={{ mt: 1 }} /> 
      <Skeleton height={34} width="70%" /> 

    </>
   
    : <>
    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={{ position: "relative", zIndex: 1 }}>
      <Stack spacing={0.75}>
        <Typography variant="overline" sx={{ letterSpacing: 1.4, ...dashboardMutedTextSx(theme) }}>
          Current Funds
        </Typography>
        <Typography sx={{ fontSize: 28, lineHeight: 1.1 }}>
          ${Number(getBalanceForAsset(summary, user.fundingCurrency || DEFAULT_FUNDING_CURRENCY)?.free).toFixed(2)} {user.fundingCurrency}
        </Typography>
        <Typography variant="body2" sx={dashboardMutedTextSx(theme)}>
          Current funds for your base pair
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "10px",
            display: "grid",
            placeItems: "center",
            backgroundColor: alpha(theme.palette.info.main, theme.palette.mode === "dark" ? 0.16 : 0.12),
            color: theme.palette.info.main,
          }}
        >
          <StackedLineChart fontSize="large"/>
        </Box>
        <Button
          color="info"
          variant="contained"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          endIcon={<MoreVert />}
          sx={{
            borderRadius: 999,
            boxShadow: "none",
            px: 2,
          }}
        >
          More Assets
        </Button>
      </Stack>
    </Stack>

    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      >
       {summary?.account?.balances?.filter(balance => Number(balance.free) > 0).map((balance, key) => <MenuItem onClick={() => handleShowSellModal(balance)} key={key}>{balance.asset} | free: {balance.free}</MenuItem>)}

      </Menu>

    </>}

      { !!showSellModalWithPair && <BuySellModal side="sell" waitForBearSignal={false} tradingPair={showSellModalWithPair} open={!!showSellModalWithPair} handleClose={() => setShowSellModalPair("")} maxSell={getMaxSell()} /> }
    
  </Card>
  )
}
